// Constantes de dominio del módulo timeentry. Eliminan los magic strings que
// estaban repartidos por diálogos, mappers y efectos.

// Tipo de imputación que entiende el backend.
export const CHARGE_TYPE = {
  AUTOMATIC: "Automatic",
  MANUAL: "Manual",
};

// Granularidad de la carga automática.
export const TYPE_OF_CHARGE = {
  WEEK: "Week",
  MONTH: "Month",
};

// Actividades que NO computan horas (festivo / licencia sin goce). El backend las
// identifica por descripción; el match es case-insensitive por substring y cubre
// los dos call sites históricos (ChargedHourDialog y MissingHourDialog).
export const ZERO_HOUR_ACTIVITY_MATCHERS = ["festive", "unpaid leave"];

// Actividades especiales que se muestran con 0 horas faltantes en el resumen.
export const SPECIAL_ACTIVITY_IDS = [13, 15];

export const HOURS_PER_DAY = 8;
export const WORK_DAYS_PER_WEEK = 5;
export const FULL_WEEK_HOURS = 40;
